import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import { GlobalService } from './global.service';
import {
  DashboardFilter,
  InitialDashboardFilter,
} from '../interfaces/dashboard.interface';

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  constructor(private http: HttpClient, private _global: GlobalService) {}

  createEnterpriseUser(enterpriseUserRequestDTO) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createEnterpriseUser}`,
      enterpriseUserRequestDTO
    );
  }
  getAllEnterpriseUsers(pageNumber, pageSize, search?) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize)
      .set('searchParams', search ?? '');

    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllEnterpriseStaffs}`,
      { params }
    );
  }
  getActiveEnterpriseUsers(pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getActiveEnterpriseStaffs}`,
      { params }
    );
  }

  getUserProfile() {
    return this.http.get(`${environment.API_URL_V1}/${endpoints.profile}`);
  }

  updateEnterpriseUser(payload) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateEnterpriseUser}`,
      payload
    );
  }

  uploadAvatar(formData) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.uploadAvatar}`,
      formData
    );
  }
  uploadStaffAvatar(formData, staffId) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.uploadUserAvatar}/${staffId}/upload_avatar`,
      formData
    );
  }
  toggleActivateDeactivateStaff(id) {
    const payload = {};
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.activateDeactivateStaff}/${id}/toggle_activation`,
      payload
    );
  }

  getOneEnterpriseUser(id) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getOneEnterpriseUser}/${id}`
    );
  }

  updateOneEnterpriseUser(updatedInfo, staffId) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateOneEnterpriseUser}/${staffId}/update`,
      updatedInfo
    );
  }

  getAssignedCourses(pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.assignedCourses}/assigned_courses`,
      { params }
    );
  }

  getAssignedLearningPath(pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.assignedLearningPaths}/assigned_learning_paths`,
      { params }
    );
  }
  getStaffAssignedCourses(staffId, pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.assignedCourses}/${staffId}/assigned_courses`,
      { params }
    );
  }

  getStaffAssignedLearningPath(staffId, pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.assignedLearningPaths}/${staffId}/assigned_learning_paths`,
      { params }
    );
  }

  getEnrolledCourses(pageNumber, pageSize) {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('size', pageSize);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getEnrolledCourses}`,
      { params }
    );
  }

  sendMessage(payload, staffId) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.sendMessage}/${staffId}/messages/send`,
      payload
    );
  }
  getDashboardContents(filterParam?: DashboardFilter) {
    if (!filterParam) {
      filterParam = InitialDashboardFilter;
    }

    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.getDashboardContents}`,
      filterParam
    );
  }

  setWeeklyGoal(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.setWeeklyGoal}`,
      payload
    );
  }
}
